import React, { useMemo, useState } from 'react';
import { Card, Form, Button, Alert, Container } from 'react-bootstrap';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../lib/api';

export default function PasswordResetConfirmPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const uid = useMemo(() => params.get('uid') || '', [params]);
  const token = useMemo(() => params.get('token') || '', [params]);
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setMsg('');
    try {
      const res = await api.post('/accounts/password-reset/confirm/', { uid, token, password });
      setMsg(res.data?.message || 'Password reset successful');
      setTimeout(() => navigate('/login'), 1200);
    } catch (ex) {
      setErr(ex?.response?.data?.error || 'Unable to reset password');
    }
  };

  return (
    <Container style={{ maxWidth: 520, marginTop: 60 }}>
      <Card className="p-4">
        <h5>Set New Password</h5>
        {msg && <Alert variant="success">{msg}</Alert>}
        {err && <Alert variant="danger">{err}</Alert>}
        <Form onSubmit={submit}>
          <Form.Group className="mb-3">
            <Form.Label>New password</Form.Label>
            <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} />
          </Form.Group>
          <Button type="submit" disabled={!uid || !token}>Reset password</Button>
        </Form>
      </Card>
    </Container>
  );
}
